// ── LOAD MORE ──────────────────────────────────────────────
(function () {
  // Megkeressük a gombot (keresési oldalon az ID alapján, kollekció oldalon a data-attribútum alapján)
  var btn = document.getElementById('ez-load-more-btn') || document.querySelector('[data-load-more-btn]');
  if (!btn) return;

  var isLoading = false;

  function loadMore() {
    if (isLoading) return;
    // A megfelelő attribútumból olvassuk ki a linket
    var url = btn.getAttribute('href') || btn.getAttribute('data-next-url');
    if (!url) return;

    isLoading = true;
    btn.textContent = 'Betöltés...';
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Új termékek hozzáadása a meglévő gridhez
        var newItems = doc.querySelectorAll('.productgrid--items .productgrid--item');
        var grid = document.querySelector('.productgrid--items');
        if (grid && newItems.length > 0) {
          newItems.forEach(function (item) {
            grid.appendChild(item);
          });
        }

        // Következő oldal gomb frissítése vagy eltávolítása
        var newBtn = doc.getElementById('ez-load-more-btn') || doc.querySelector('[data-load-more-btn]');
        var container = btn.parentElement;
        
        if (newBtn) {
          var newUrl = newBtn.getAttribute('href') || newBtn.getAttribute('data-next-url');
          // Visszaírjuk a linket a megfelelő attribútumba
          if (btn.hasAttribute('href')) {
            btn.setAttribute('href', newUrl);
          } else if (btn.hasAttribute('data-next-url')) {
            btn.setAttribute('data-next-url', newUrl);
          }
          
          btn.textContent = 'Több termék';
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
          isLoading = false;
        } else {
          if (container) container.remove(); // Nincs több oldal
          if (observer) observer.disconnect(); // Leállítjuk a figyelést
        }
      })
      .catch(function () {
        btn.textContent = 'Hiba – próbáld újra';
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
        isLoading = false;
      });
  }

  // Kattintás esemény (fallback)
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    loadMore();
  });

  // Automatikus betöltés görgetésre
  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      loadMore();
    }
  }, {
    rootMargin: '400px'
  });

  observer.observe(btn);
})();